import React from 'react'
import './Common.css'
import { BsCheckLg } from 'react-icons/bs'

const Card = ({ data }) => {
    return (
        <div key={data.id} className='price-card'>
            {/* <div className="price-card-top"></div> */}
            <div className='price-card-temp'>
                <h2>{data.price}</h2>
                <p>{data.subtitle}</p>
                <div className='card-features'>
                    {data?.features?.map(f => (
                        <p><BsCheckLg className='price-check-icon' /> {f.title}</p>
                    ))}
                </div>
            </div>
        </div>
    )
}

export default Card